import api from './api';

export const enviarSugestao   = (dados)  => api.post('/sugestoes', dados);
export const listarMinhas     = ()       => api.get('/sugestoes');
export const listarTodasAdmin = (status) => api.get('/sugestoes/admin', { params: status ? { status } : {} });
export const atualizarSugestao = (id, dados) => api.patch(`/sugestoes/admin/${id}`, dados);
